export const WEEK_DAYS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

// 设备协议明确为周一00:00起的168位；不截断、不补位，避免把坏数据画成有效计划。
export function weeklyPlan (input) {
  const value = input && typeof input === 'object' && !Array.isArray(input) ? input.value : input
  if (value === undefined || value === null || value === '') return { empty: true, rows: [], on: 0, off: 0, summary: '尚无时间计划' }
  if (typeof value !== 'string' || !/^[01]{168}$/.test(value)) throw new Error('时间计划应为168位0或1，从周一00:00开始')
  const rows = WEEK_DAYS.map((name, day) => ({ name, cells: Array.from(value.slice(day * 24, day * 24 + 24), bit => bit === '1') }))
  const on = Array.from(value).filter(bit => bit === '1').length
  let summary = `每周开 ${on} 小时，关 ${168 - on} 小时`
  if (rows.every(row => row.cells.join('') === rows[0].cells.join(''))) {
    const spans = []
    for (let hour = 0; hour < 24;) {
      if (!rows[0].cells[hour]) { hour++; continue }
      const start = hour
      while (hour < 24 && rows[0].cells[hour]) hour++
      spans.push(`${String(start).padStart(2, '0')}:00—${String(hour).padStart(2, '0')}:00`)
    }
    summary = spans.length ? `每天 ${spans.join('、')} 开` : '每天全时段关闭'
  }
  return { empty: false, rows, on, off: 168 - on, summary }
}

export function weeklySample (message, deviceId, property) {
  if (message && message.success === false) throw new Error(message.message || '时间计划订阅失败')
  const payload = message && message.payload, row = payload && payload.value
  if (!payload) return null
  if (!row || typeof row !== 'object' || !Object.prototype.hasOwnProperty.call(row, 'value')) throw new Error('时间计划上报格式不正确')
  if ((row.deviceId && String(row.deviceId) !== deviceId) || (row.property && row.property !== property)) return null
  if (!['number', 'string'].includes(typeof payload.timestamp) || !String(payload.timestamp).trim() || !Number.isFinite(Number(payload.timestamp))) throw new Error('时间计划上报时间不正确')
  weeklyPlan(row.value)
  return { value: row.value, timestamp: Number(payload.timestamp) }
}

export const WEEK_SCHEDULE_OPTION_KEYS = ['showLegend', 'showSummary', 'showModeLabel', 'fontSize', 'color', 'mutedColor', 'onColor', 'offColor', 'gridColor', 'backgroundColor']
export const createWeekSchedule = () => ({ name: '周时间计划', title: '周时间计划', icon: 'el-icon-date', dataType: 0, time: 0,
  data: { value: '011111111111000000000000'.repeat(7) }, parameter: { deviceSource: 'page', deviceId: '', productId: '', property: 'time_table' },
  component: { name: 'weekSchedule', prop: 'weekSchedule', width: 520, height: 300 },
  option: { showLegend: true, showSummary: true, showModeLabel: true, fontSize: 14, color: '#d8f4ff', mutedColor: '#8caac0', onColor: '#19d8ed', offColor: '#233d55', gridColor: '#386078', backgroundColor: 'transparent' } })
